module.exports = __webpack_public_path__ + "media/images/login/login_t1-187398460ac45636fa6858704f0874d4.gif";